import React from "react";
import axios from "axios";

//Matrial-ui core
import { CircularProgress, Dialog, DialogContent, DialogTitle, Slide } from "@mui/material";
import { Close } from "@mui/icons-material";
import { withStyles } from "tss-react/mui";

//Core items
import Button from "../../../components/CustomButtons/Button";
import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class CikamStatusModal extends React.Component {
  state = {
    status: {},
    loading: true,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open && prevProps.open !== this.props.open) {
      this.loadApiLog();
    }

    if (this.props.open === false && prevProps.open !== this.props.open) {
      this.setState({ loading: true });
    }
  }

  loadApiLog = () => {
    axios.get("core/vestigingen/" + this.props.vestiging_id + "/getcikamstatus").then((response) => {
      if (response.data.data.success) {
        this.setState({
          status: response.data.data.status,
          loading: false,
        });
      } else {
        //TODO
      }
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth={true}
        keepMounted
        maxWidth={"lg"}
        onClose={this.props.toggle}
        open={this.props.open}
        scroll={"paper"}
      >
        <div>
          <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
            <Button
              aria-label={"Close"}
              className={classes.modalCloseButton}
              color={"transparent"}
              justIcon
              key={"close"}
              onClick={this.props.toggle}
            >
              <Close className={classes.modalClose} />
            </Button>
            <h4 className={classes.modalTitle}>Status</h4>
          </DialogTitle>
          {!this.state.loading ? (
            <div>
              <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
                <textarea
                  defaultValue={JSON.stringify(this.state.status, null, 2)}
                  disabled
                  style={{ width: "100%", minHeight: "500px", height: "100%" }}
                />
              </DialogContent>
            </div>
          ) : (
            <div style={{ margin: "25px auto" }}>
              <CircularProgress />
            </div>
          )}
        </div>
      </Dialog>
    );
  }
}

export default withStyles(CikamStatusModal, notificationsStyle);
